import { useTranslation } from '@nextgen-web-framework/all';
import styles from './SearchCloseButton.module.scss';
import { SearchbarCloseButtonprops } from './types/propsType';

const SearchCloseButton = ({ overlayCloseHandler }: SearchbarCloseButtonprops) => {
  const t = useTranslation();
  return (
    <div className={styles['close-btn-container']}>
      <span
        role="button"
        aria-label="Close Search"
        className={styles.closeBtn}
        data-testid="close-btn-testId"
        onClick={overlayCloseHandler}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            overlayCloseHandler(e);
          }
        }}
      >
        {t('web.closeButtonLabel')}
      </span>
    </div>
  );
};

export default SearchCloseButton;
